import InputButton from '../input-button/InputButton'
// import { ScaleOut, DoubleBounce, CubeShadow } from 'vue-loading-spinner'
import { ApiError } from '../../services/api.service'

export default {
    name: 'Loader',
    components: {
        InputButton,
        // ScaleOut,
        // DoubleBounce
    },

    props: {
        loading: Boolean,
        error: Error,
        errorMessage: String
    },

    methods: {
        retry() {
            this.$emit('retry')
        }
    }
}
